<template>
  <div id="userInvoice" class="gradient-card card">
    <div class="header">
      <div :class="panelHeaderIconClass"></div>
        <h4 class="title">{{panelHeaderTitle}}</h4>
      </div>

    <div class="body invoices">
      <div class="yearly-calendar-wrapper">
        <yearly-calendar v-if="invoicesFilterByYearMonth !== null"
          :selectedYearProp="calendarYear"
          :selectedMonthProp="calendarMonth"
          :yearOptionsProp="calendarYearOptions"
          :calendarDataProp="invoicesFilterByYearMonth"
          @yearly-calendar-change="handleYearlyCalendarChanged($event)">
        </yearly-calendar>
      </div>

      <perfect-scrollbar v-if="invoiceListToShow.length > 0" class="invoice-list cstm-ps-scrollbar-vertical">
        <table cellspacing="0" cellpadding="0">
          <thead>
            <tr>
              <td>{{$t('label.invoice', 1)}}</td>
              <td>{{$t('label.date')}}</td>
              <td>{{$t('label.amount')}}</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(invoice, indx) in invoiceListToShow" :key="indx" @click="handleRowClick(invoice)">
              <td>{{invoice._edit.invoiceId}}</td>
              <td>{{invoice._edit.billingDate}}</td>
              <td>{{invoice._edit.amountWithCurrency}}</td>
            </tr>
          </tbody>
        </table>
      </perfect-scrollbar>
    </div>
  </div>
</template>

<script src="./user-invoice-list.js"></script>
<style lang="scss" src="./user-invoice-list.scss"></style>
